module.exports = __webpack_public_path__ + "img/image01_sp.343cfffe.jpg";